import { Chip, type ChipProps } from '@mui/material';
import type { TenantSummary } from './platformApi.ts';

const byStatus: Record<string, { label: string; color: ChipProps['color'] }> = {
  active: { label: 'Active', color: 'success' },
  trialing: { label: 'Trial', color: 'info' },
  past_due: { label: 'Past due', color: 'warning' },
  unpaid: { label: 'Unpaid', color: 'warning' },
  incomplete: { label: 'Incomplete', color: 'warning' },
  canceled: { label: 'Canceled', color: 'error' }
};

/** A tenant's Stripe status. Tenants set up by hand have none and read as Manual. */
const TenantStatusChip = ({ tenant }: { tenant: TenantSummary }) => {
  if (tenant.demo) {
    return <Chip size="small" label="Demo" variant="outlined" />;
  }
  if (!tenant.subscriptionStatus) {
    return <Chip size="small" label="Manual" variant="outlined" />;
  }
  const status = byStatus[tenant.subscriptionStatus] ?? {
    label: tenant.subscriptionStatus,
    color: 'default' as const
  };
  return <Chip size="small" label={status.label} color={status.color} />;
};

export default TenantStatusChip;
